/* tslint:disable */

declare var Object: any;
export interface StorageProfileInterface {
  "id"?: number;
}

export class StorageProfile implements StorageProfileInterface {
  "id": number;
  constructor(data?: StorageProfileInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StorageProfile`.
   */
  public static getModelName() {
    return "StorageProfile";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StorageProfile for dynamic purposes.
  **/
  public static factory(data: StorageProfileInterface): StorageProfile{
    return new StorageProfile(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StorageProfile',
      plural: 'StorageProfiles',
      path: 'StorageProfiles',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/StorageProfile.ts